
<script>
import BarList from '../components/bar-list'
import { apiORDSdelete } from '../shared/api-functions'
import { SysVars } from '../main';
import CrmOrigemForm from './crm-origem-form'
import apiCrm from '../api/api-crm.js'

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            codorigem: null,
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        origemList: function () {
            return this.$store.getters.getOrigemCrmList
        },
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },
    },

    methods: {
        handleEdit (origem) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.$set(origem, 'show', true)
        },

        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.showForm = true
        },

        closeForm(origem) {
            if (origem)
              origem.show = false
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codorigem":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadOrigemCrm', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        },

        handleDelete (origem) {
            //BOTAO Excluir
            this.apiOrigemDelete(origem.codorigem)
            this.loadData()
        },

    },

    components: {
        BarList, CrmOrigemForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Origem do Contato" 
                plural-entity=""
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list>
            <br>
            <div class="default-container">
                <crm-origem-form v-if="showForm" :index="codorigem" :crud="crud" @closeform="closeForm"></crm-origem-form>
                <alert v-if="origemList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="origem in origemList" :key="origem.codorigem">
                    <div class="box">
                        <div class="row" v-show="!origem.show">
                            <!-- <div class="col-md-2 col-3">
                                <span class="lbl-list"> {{metadata.origemcrm.codorigem.label}} </span>
                                <span class="data-list">{{ origem.codorigem }}</span>
                            </div> -->
                            <div class="col-md-10 col-6">
                                <!-- <span class="lbl-list"> {{metadata.origemcrm.descricao.label}} </span> -->
                                <span class="lbl-title-produto">{{ origem.descricao }}</span>
                            </div>
                            <div class="col-md-2 col-12">
                                <bar-grid 
                                    :options="{barDefault: true, btnDelete: true, btnEdit: true}" 
                                    :moreActions="[]" 
                                    @edit="handleEdit(origem)" 
                                    @delete="handleDelete(origem)">
                                </bar-grid>
                            </div>
                        </div>
                        <crm-origem-form v-if="origem.show" :index="origem.codorigem" :crud="crud" @closeform="closeForm(origem)"></crm-origem-form>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<style>

</style>





// WEBPACK FOOTER //
// src/forms-crm/crm-origem-list.vue